<template>
  <div class="text-left row mt-5 mb-5">
    <div class="container">
      <div class="row">
        <div class="col">
          <h2 class="text-white subtitle">Licença LembraZap</h2>
          <div class="card p-3">
            <h4 class="text-white subtitle">Assinatura</h4>
            <div v-if="!lzValidade">
              <p>Nenhuma assinatura encontrada, selecione assinar para fazer uso de nossos serviços!</p>
              <h5 class="text-white pt-3">LembraZap</h5>
              <p>Automação de envio de mensagens via Whatsapp! Com a LembraZap, você vai conversar com mais pessoas ao
                mesmo tempo, mandar lembretes, fazer campanhas, parabenizar pelo aniversário e muito mais</p>
              <p>Licença : até 150 mensagens por dia – R$ 300,00</p>
              <button class="btn btn-info" @click="form.ativo = !form.ativo">Assinar Licença LembraZap</button>
            </div>
            <div v-if="lzValidade">
              <p class="pt-3">Licença válida</p>
              <p>Validade: {{ getValidade() }} </p>
              <button class="btn btn-info" @click="form.ativo = !form.ativo">Renovar Licença</button>
            </div>
          </div>

          <div v-show="form.ativo" class="card p-3">
            <h4 class="text-white subtitle">Dados de identificação</h4>
            <div class="row">
              <div class="form-group col-sm-12 col-md-6">
                <div class="form-group col">
                  <label for="email">Email de confirmação:</label>
                  <input class="form-control" type="email" id="email" placeholder="Digite seu email"
                    v-model="form.email" />
                </div>
              </div>
              <div class="form-group col-md-6">
                <div class="form-group col">
                  <label for="cpfcnpj">CPF/CNPJ para identificação:</label>
                  <the-mask :mask="['###.###.###-##', '##.###.###/####-##']" @blur.native="validaCpfCnpj"
                    placeholder="Digite seu CPF" v-model="form.cpfcnpj" ref="cpfcnpj" id="cpfcnpj"
                    class="form-control" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-group col">
                <label for="tipoPagamento">Tipo de pagamento:</label>
                <select name="tipoPagamento" v-model="form.tipoPagamento" class="form-control" id="tipoPagamento">
                  <option value="credit_card">CARTÃO DE CRÉDITO</option>
                  <option value="boleto">BOLETO</option>
                </select>
              </div>

              <button type="submit" @click="ckeckPagamento()" class="col mt-1 align-self-end btn-md btn btn-success">
                Pagamento
                <font-awesome-icon icon="chevron-down" />
              </button>
            </div>
          </div>

          <div v-show="recarga.status || boletoGerado.url">
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div class="col mt-3 alert alert-success">Processo concluído com sucesso.Confira os detalhes abaixo
                  </div>
                </div>
                <div class="col">
                  <div class="card">
                    <div class="card-header success">Dados da recarga solicitada</div>
                    <div class="card-body card-body-dark">
                      <blockquote class="blockquote mb-0">
                        <p class="dadosRecarga">Id: {{ recarga._id }}</p>
                        <p class="dadosRecarga">Valor da assinatura: {{ recarga.valor | money}}</p>
                        <p class="dadosRecarga">Validade: 30 dias</p>
                        <p class="dadosRecarga">Liberado até 150 envios de whatsapp por dia</p>
                        <p class="dadosRecarga">CPF/CNPJ: {{ recarga.cpfcnpj | cpfcnpj}}</p>
                        <p class="dadosRecarga">Email de contato: {{ recarga.emailConfirmacao }}</p>
                        <p class="dadosRecarga">Tipo de pagamento: {{ getTipoPagamento(recarga.tipoPagamento) }}</p>
                      </blockquote>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="card" v-if="form.tipoPagamento === 'boleto'">
                    <div class="card-header warning">Solicitação finalizada</div>
                    <div class="card-body card-body-dark">
                      <blockquote class="blockquote mb-0">
                        <p class="dadosRecarga">
                          Você pode baixar o boleto
                          <span class="dadoBoleto">
                            <a class="warningPagamento" :href="boletoGerado.url">AQUI</a>
                          </span>
                        </p>
                        <p class="dadosRecarga">
                          Linha digitável:
                          <span class="dadoBoleto">{{boletoGerado.barcode}}</span>
                        </p>
                        <p class="dadosRecarga">Tambem enviaremos o boleto para pagamento no email informado</p>
                        <p class="dadosRecarga">Após a confirmação do pagamento, é feita a liberação do saldo</p>
                        <small class="warningPagamento">*O pagamento do boleto pode levar até três dias para ser
                          processado</small>
                      </blockquote>
                    </div>
                  </div>
                  <div class="card" v-if="form.tipoPagamento === 'credit_card'">
                    <div class="card-header success">Recarga finalizada</div>
                    <div class="card-body card-body-dark">
                      <blockquote class="blockquote mb-0">
                        <p class="dadosRecarga">O cartão ja aprovou sua compra</p>
                        <p class="dadosRecarga">Seu envio já está liberado</p>
                      </blockquote>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import cnpfCnpjValidator from "./../../core/cnpfCnpjValidator";

  export default {
    data() {
      return {
        lzValidade: false,
        valorLicenca: 300,
        processandoPagamento: false,
        cpfCnpjChecked: false,
        cpfCnpjOk: false,
        showError: false,
        assinatura: '',
        form: {
          lz: true,
          ativo: false,
          cpfcnpj: '',
          email: '',
          tipoPagamento: 'credit_card',
          pagarme: {},
        },
        recarga: {
          status: false,
        },
        boletoGerado: {},
      };
    },
    methods: {
      getValidade() {
        if (this.lzValidade)
        return moment(this.lzValidade).format('DD/MM/YYYY');
      },
      getTipoPagamento(tipo) {
        switch (tipo) {
          case "boleto":
            return "BOLETO";
          case "ted":
            return "TED";
          case "credit_card":
            return "CARTÃO DE CRÉDITO";
        }
      },
      validaCpfCnpj() {
        let valid = false;

        if (this.form.cpfcnpj.length == 11) {
          valid = cnpfCnpjValidator.isValidCpf(this.form.cpfcnpj);
        } else if (this.form.cpfcnpj.length > 11) {
          valid = cnpfCnpjValidator.isValidCnpj(this.form.cpfcnpj);
        }

        this.cpfCnpjOk = valid;
        this.cpfCnpjChecked = true;
      },
      ckeckPagamento() {
        if (
          this.form.cpfcnpj.length < 11 ||
          !this.form.email ||
          !this.cpfCnpjOk
        ) {
          this.$toasted.show(
            "Complete todos os campos, informe um cpf válido", {
              icon: "times",
              type: "error"
            }
          );
        } else {
          this.pagarmeCheckout();
        }
      },
      pagarmeCheckout() {
        const app = this;
        const checkout = new PagarMeCheckout.Checkout({
          encryption_key: process.env.VUE_APP_PAGARME_ENC_KEY,

          success: function (data) {
            app.form.pagarme.token = data.token;
            app.form.pagarme.payment_method = data.payment_method;
            console.log(data);
            console.log("proximo passo");
            app.confirm();
          },
          error: function (err) {
            console.log(err);
          },
          close: function () {
            console.log("The modal has been closed.");
          }
        });

        // Obs.: é necessário passar os valores boolean como string
        let items = [];
        let valor = this.valorLicenca * 100;
        valor = valor.toString();

        let obj = {
          amount: valor,
          buttonText: "Pagar",
          buttonClass: "btnPagarme",
          customerData: "true",
          uiColor: "#212529",
          createToken: "true",
          items: items,
          paymentMethods: this.form.tipoPagamento
        };

        if (this.form.tipoPagamento == "credit_card") {
          obj.items = [{
            id: moment().unix(),
            title: "Assinatura LembraZap",
            unit_price: valor,
            quantity: 1,
            tangible: false
          }];
        } else {
          obj.postback_url = process.env.VUE_APP_PAGARME_POSTBACK_URL;
        }

        checkout.open(obj);
      },
      async confirm() {
        this.processandoPagamento = true;

        let response = await this.$http.post(
          "/v1/recargas/assinaLZ",
          this.form
        );

        this.processandoPagamento = false;

        if (response.success) {
          this.form.ativo = false;
          this.recarga = response.recarga;
          if (response.boleto) this.boletoGerado = response.boleto;
        } else {
          this.showError = true;
          this.errorMessage = response.err;
        }
      }
    },
    async mounted() {
        const data = await this.$http.get('/v1/v3/meu-perfil');
        this.lzValidade = data.data.lzValidade;
    },
  };
</script>